import keyMirror from 'keymirror';
import practiceQuestionsImage from '../../images/illustrations/icons/practiceQuestions.svg';
import diagnosticTest1Image from '../../images/illustrations/icons/diagnosticTest1.svg';
import videoImage from '../../images/illustrations/icons/video.svg';
import extraOptionsImage from '../../images/illustrations/icons/extraOptions.svg';
import manyQuestionsImage from '../../images/illustrations/icons/manyQuestions.svg';
import settingsImage from '../../images/illustrations/icons/settings.svg';
import multipleChoiceImage from '../../images/illustrations/icons/multipleChoice.svg';
import inYourMindCloudImage from '../../images/illustrations/icons/inYourMindCloud.svg';
import languagesImage from '../../images/illustrations/icons/languages.svg';
import mixerImage from '../../images/illustrations/icons/mixer.svg';
import qnaSingleImage from '../../images/illustrations/supporting/qnaSingle.svg';
import groupImage from '../../images/illustrations/supporting/group.svg';

export const packageCancellationActionTypes = keyMirror({
	GET_PACKAGE_CANCELLATION_DATA_REQUEST: null,
	GET_PACKAGE_CANCELLATION_DATA_SUCCESS: null,
	GET_PACKAGE_CANCELLATION_DATA_ERROR: null,

	SET_PACKAGE_CANCELLATION_DATA: null,
	RESET_STATE: null,

	APPLY_OFFER_REQUEST: null,
	APPLY_OFFER_SUCCESS: null,
	APPLY_OFFER_ERROR: null,
});

export const statsImages = {
	practise_questions: practiceQuestionsImage,
	diagnostic_test: diagnosticTest1Image,
	video_play_btn: videoImage,
	extra_options: extraOptionsImage,
	mixer: mixerImage,
	many_questions: manyQuestionsImage,
	settings: settingsImage,
	multiple_choice: multipleChoiceImage,
	in_your_mind_cloud_image: inYourMindCloudImage,
	languages: languagesImage,
};

export const getConfirmationImage = (type) => {
	switch (type) {
		case 'sendNotification':
			return qnaSingleImage;
		case 'cancelled':
			return groupImage;

		default:
			return extraOptionsImage;
	}
};

export const freeFeatures = [
	'usp_unlimited_list_exercises_limited_modes',
	'usp_unlimited_list_exercises_limited_modes',
	'usp_unlimited_quiz_exercises',
	'usp_language_exercises',
];

export const filterUSPSbyFreeFeatures = (arr, filterArr) =>
	arr.filter((el) => filterArr.every((item) => item !== el.explanation_block_identifier));

export const hasOtherToolOptionSelected = (selectedTools) =>
	selectedTools && selectedTools.some((item) => item.other);

export const reasons = {
	missing_book: 'define_missing_book',
	other_tool: 'define_other_tool',
	other_expectations: 'define_expectation_reason',
	others: 'define_other_reason',
};

const formatToolName = (toolName) =>
	`tool_${toolName.toLowerCase().replaceAll(' ', '_').replaceAll('.', '')}`;

export const formatSelectedTools = (tools, allTools) => {
	return Object.fromEntries(
		allTools.map(({ name: toolName }) => {
			const isSelected = tools.some(({ name }) => name === toolName);
			return [[formatToolName(toolName)], isSelected];
		}),
	);
};

export const actions = {
	default: 'closed_panel',
	cancel_btn: 'clicked_dont_cancel_button',
	reminder: 'cancellation_trial_end_reminder_scheduled',
	money_back: 'cancellation_moneyback_clicked',
	subject: 'cancellation_subject_topics_clicked',
	offer: 'cancellation_offer_accepted',
	support: 'support_clicked',
	upgrade: 'switch_membership_clicked',
};
